import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Form, Button, Card, Space, Spin, Alert, message } from "antd"; // Ajoutez message
import FormFields from "../AddUsersPage/FormFields";
import { getUserById, updateUser } from "../../../redux/slices/users/usersThunk";
import { fetchRoles } from "../../../redux/slices/roles/rolesThunk";

const EditUsersPage = () => {
  const { id: userId } = useParams();
  const [form] = Form.useForm();
  const history = useHistory();
  const dispatch = useDispatch();

  const { data: userToEdit, status: userStatus, error: userError } = useSelector((state) => state.users.oneUser);
  const { rolesList, status: rolesStatus } = useSelector((state) => state.roles);
  
  const isLoading = userStatus === 'loading' || rolesStatus === 'loading';

  useEffect(() => {
    if (userId) {
      dispatch(getUserById(userId));
    }
    dispatch(fetchRoles());
  }, [dispatch, userId]);

  useEffect(() => {
    if (userToEdit) {
      form.setFieldsValue({
        firstName: userToEdit.firstName,
        lastName: userToEdit.lastName,
        email: userToEdit.email,
        phone: userToEdit.phone,
        role: userToEdit.role?.id,
        status: userToEdit.status?.id === 1, // Supposons que 1 = Actif
      });
    }
  }, [userToEdit, form]);

  // ==========================================================
  // === CORRECTION DE LA FONCTION onFinish ===
  // ==========================================================
  const onFinish = (values) => {
    // 1. On ne prépare que les données qui ont changé
    const payload = {};
    for (const key in values) {
      // On vérifie si la valeur est définie et différente de celle d'origine
      // C'est une sécurité supplémentaire
      if (values[key] !== undefined && values[key] !== userToEdit[key]) {
        // Cas spécial pour le mot de passe vide
        if (key === 'password' && values[key] === '') {
            continue; // On n'envoie pas de mot de passe vide
        }
        payload[key] = values[key];
      }
    }

    // 2. On formate le rôle et le statut pour l'API
    if (payload.role) {
      payload.role = { id: payload.role };
    }
    if (payload.status !== undefined) {
      payload.status = { id: payload.status ? 1 : 2 };
    }

    // Si aucun champ n'a été modifié, on n'envoie pas de requête
    if (Object.keys(payload).length === 0) {
        message.info("Aucune modification détectée.");
        return;
    }
    
    // 3. On gère la promesse correctement avec .unwrap()
    dispatch(updateUser({ userId, userData: payload }))
      .unwrap()
      .then(() => {
        message.success("Utilisateur mis à jour avec succès !");
        history.push("/utilisateurs");
      })
      .catch((err) => {
        message.error("Erreur lors de la mise à jour de l'utilisateur.");
        console.error("Erreur de mise à jour :", err);
      });
  };

  if (isLoading) return <Spin tip="Chargement..." />;
  if (userError) return <Alert message="Erreur de chargement" description={userError} type="error" showIcon />;

  return (
    <Card title={`Modifier l'utilisateur : ${userToEdit?.firstName || ''} ${userToEdit?.lastName || ''}`}>
      <Form form={form} onFinish={onFinish} labelCol={{ span: 8 }} wrapperCol={{ span: 12 }}>
        <FormFields roles={rolesList} isRolesLoading={rolesStatus === 'loading'} isEditing={true} />
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Space>
            <Button type="primary" htmlType="submit">
              Enregistrer les modifications
            </Button>
            <Button onClick={() => history.push("/utilisateurs")}>
              Annuler
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default EditUsersPage;